import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Backdrop, CircularProgress } from '@mui/material';
import api from '../api/api';
import ToastMessage from '../utils/muitoast';

const ReportAuthorizer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('info'); // 'success' | 'error' | 'warning' | 'info'
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const authToken = queryParams.get('authtoken');
    const nav=queryParams.get('navigation')

    if (!authToken) {
      showToast('Invalid or missing token.', 'error');
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } else {
      fetchToken(authToken,nav);
    }
  }, [location.search, navigate]);

  const fetchToken = async (authToken,nav) => {
    setLoader(true);
    try {
      const response = await api.get(`/auth/reports/sso?authtoken=${authToken}`);
      console.log(response.data)
      const receivedToken = response?.access_token||'';

      if (receivedToken) {
        // navigate(`/report?allow=${receivedToken}`);
if(nav =='report'){
window.location.href = `/report?allow=${receivedToken}`
}else if(nav=='forms'){
   window.location.href = `/forms?allow=${receivedToken}`
}
else{
  window.location.href = `/report?allow=${receivedToken}`
}

        
      } else {
       showToast('Failed to authorize. Redirecting...', 'error');
         setTimeout(() => {
        navigate('/');
      }, 3000);
      }
    } catch (error) {
      console.error('Error fetching token:', error);
      showToast('Failed to authorize. Redirecting...', 'error');
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } finally {
      setLoader(false);
    }
  };

  const showToast = (message, type) => {
    setAlertMessage(message);
    setSeverity(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div style={{ padding: '20px', fontSize: '18px' }}>
        Validating token...
      </div>

      <ToastMessage
        message={alertMessage}
        severity={severity}
        open={open}
        handleClose={handleClose}
      />

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ReportAuthorizer;
